import { createStorefrontApiClient } from '@shopify/storefront-api-client';

/*
 * TODO: contains ts-ignore, we wanted to already try it out
 * since it includes external shopify dependency
 */
export const createClient = (
  storefrontAccessToken: string,
  apiVersion: string,
  storeDomain?: string,
) => {
  if (
    !storefrontAccessToken ||
    (typeof window !== "undefined" &&
      (window as any)?.CANDYRACK_SHOULD_DISABLE_STOREFRONT_API)
  ) {
    return null;
  }

  return createStorefrontApiClient({
    storeDomain: storeDomain ?? (typeof window !== "undefined" ? (window as any)?.Shopify?.shop : undefined),
    apiVersion: apiVersion,
    publicAccessToken: storefrontAccessToken,
  });
};